import React from 'react'
import "./contacto.css"
import{MdOutlineEmail} from "react-icons/md"
import{BsFacebook} from "react-icons/bs"
import{BiLogoWhatsappSquare} from "react-icons/bi"

const contacto = () => {
  return (
    <section id='contacto'>
      <h5>hablame</h5>
      <h2>CONTACTO</h2>

      <div className='container contact__container'>
        <div className='contact__options'>
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>smithelunico123@gmail.com</h5>
          </article>
          <article className='contact__option'>
            <BsFacebook className='contact__option-icon'/>
            <h4>Facebook</h4>
            <h5>Bryan Coronado</h5>
            <a href="https://www.facebook.com/profile.php?id=100072381273626" target='_blank' className='btn btn-primary'>contactar</a>
          </article>
          <article className='contact__option'>
            <BiLogoWhatsappSquare className='contact__option-icon'/>
            <h4>Whatsapp</h4>
            <h5>901064562</h5>
            <a href="https://wa.me/51901064562" target='_blank' className='btn btn-primary'>contactar</a>
          </article>
        </div>
        {/* END OF CONTACT OPTIONS*/}
        <form action="">
          <input type='text' name="name" placeholder='nombre'required/>
          <input type='email' name="email" placeholder='email'required/>
          <textarea name="messege"   rows="7" placeholder='mensaje'required></textarea>
          <button type='submit' className='btn btn-primary'>Enviar</button>
        </form>
      </div>
    </section>
  )
}

export default contacto